/**
 * @generated SignedSource<<0a82f2f62f781d21b759ccfb7bc3bb15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateCategoryInput = {
  name?: string | null;
};
export type CategoryEditFormMutation$variables = {
  id: string;
  input: UpdateCategoryInput;
};
export type CategoryEditFormMutation$data = {
  readonly updateCategory: {
    readonly " $fragmentSpreads": FragmentRefs<"CategoryEditForm_category" | "EntitySidebar_entity">;
  };
};
export type CategoryEditFormMutation = {
  response: CategoryEditFormMutation$data;
  variables: CategoryEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "updateCategory",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CategoryEditForm_category"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CategoryEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "updateCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "483cd45184ca8d69fc931e56f6c2c5a5",
    "id": null,
    "metadata": {},
    "name": "CategoryEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation CategoryEditFormMutation(\n  $id: ID!\n  $input: UpdateCategoryInput!\n) {\n  updateCategory(id: $id, input: $input) {\n    ...CategoryEditForm_category\n    ...EntitySidebar_entity\n    id\n  }\n}\n\nfragment CategoryEditForm_category on Category {\n  id\n  name\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "59be0808c0b6019a0594187af864a7b9";

export default node;
